/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Agents_P_Json_DescInputs */

const en_cad_agents_p_json_desc = /** @type {(inputs: Cad_Agents_P_Json_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start the app with --control and send structured commands over a local socket.`)
};

/**
* | output |
* | --- |
* | "Start the app with --control and send structured commands over a local socket." |
*
* @param {Cad_Agents_P_Json_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_agents_p_json_desc = /** @type {((inputs?: Cad_Agents_P_Json_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Agents_P_Json_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_agents_p_json_desc(inputs)
});
export { cad_agents_p_json_desc as "cad.agents.p_json_desc" }